export const TRANSLATED_PROPOSAL_FIELDS = {
  id_proposta: 'Nº da Cotação',
  proposal_number: 'Nº da Proposta',
  id_empresa: 'Id da Empresa',
  id_regional: 'Id da Regional',
  id_usuario: 'Id do Usuário',
  id_prospect: 'Id do Segurado',
  id_Status: 'Status',
  id_divisao: 'Id da Divisão',
  apolice_id: 'Id da Apólice',
  tipoProposta: 'Tipo de Proposta',
  dataFinalizacao: 'Data de Finalização',
  valorCobertura: 'Valor de Cobertura',
  origem: 'Origem',
  diaVencimentoMensalidade: 'Dia de Vencimento da Mensalidade',
  dataAdesao: 'Data de Adesão',
  dataVistoria: 'Data de Vistoria',
  assinatura: 'Assinatura',
  chave: 'Chave',
  motivoReprovacaoGeral: 'Motivo de Reprovação Geral',
  ipAceite: 'Ip de Aceite',
  dataAceite: 'Data de Aceite',
  dataVencimentoAvista: 'Data de Vencimento À Vista',
  dataSincronizacaoSTAR: 'Data de Sincronização STAR',
  vistoriaFeitaPeloConsultor: 'Vistoria Feita Pelo Consultor',
  id_cupom: 'Cupom',
  id_motivo_recusa: 'Motivo de Recusa',
  obsRecusa: 'Observação de Recusa',
  id_campanha: 'Campanha',
  JsonFacilitador: 'Json do Facilitador',
  geraCobranca: 'Gera Cobrança',
  boletoFisico: 'Boleto Físico',
  codigo_externo: 'Código Externo',
  cpfcnpj_indicador: 'Indicador CPF/CNPJ',
  JsonFacilitadorProdutos: 'Json de Produtos do Facilitador',
  permiteInvoiceSelfService: 'Permite Invoice Self Service',
  idUsuarioResponsavelVistoria: 'Id do Usuário Responsável Pela Vistoria',
  origemCadastroProposta: 'Origem do Cadastro da Proposta',
  origemCadastroPropostaLink: 'Link da Origem do Cadastro da Proposta',
  out_dealership: 'Veículo saiu da Concessionária',
  propostaVisualizada: 'Proposta Visualizada',
  exibirValoresVeiculoNaProposta: 'Exibir Valores do Veículo Na Proposta',
  dataAdesaoReal: 'Data Real de Adesão',
  tipoContrato: 'Tipo de Contrato',
  inicioVigencia: 'Início da Vigência',
  fimVigencia: 'Fim da Vigência',
  agravos: 'Agravos',
  carregamentos: 'Carregamentos',
  STAR: 'STAR',
  qtdParcelas: 'Quantidade de Parcelas',
  insurance_proposal: 'PDF da Proposta/Apólice',
  insurance_quotation: 'PDF da Cotação',
  proposal_date: 'Data da Proposta',
  id_grupo: 'Id do Grupo',
  veiculoMarca: 'Marca do Veículo',
  veiculoModelo: 'Modelo do Veículo',
  qtdPortas: 'Quantidade de Portas',
  anoModelo: 'Ano do Modelo',
  anoFabricacao: 'Ano de Fabricação',
  combustivel: 'Combustível',
  placa: 'Placa',
  cilindradas: 'Cilindradas',
  cor: 'Cor',
  renavam: 'Renavam',
  km: 'Quilometragem',
  chassi: 'Chassi',
  remarcado: 'Remarcado',
  restricao: 'Restrição',
  restricaoDescricao: 'Descrição da Restrição',
  codigoFipe: 'Código FIPE',
  rastreador: 'Rastreador',
  leilao: 'Leilão',
  observacao: 'Observação',
  estadoPneu: 'Estado do Pneu',
  anoExercicioDut: 'Ano do Exercício DUT',
  placaSubstituicao: 'Placa de Substituição',
  detalhesAcessorios: 'Detalhes Dos Acessórios',
  nf: 'Nota Fiscal',
  valorNf: 'Valor da Nota Fiscal',
  dataNf: 'Data da Nota Fiscal',
  isZero: 'É Zero Km',
  id_tabelaValor: 'Id da Tabela de Valores',
  codigoVeiculoSGA: 'Código do Veículo SGA',
  sincronizacaoSga: 'Sincronização SGA',
  participaRateio: 'Participa do Rateio',
  quantidadePassageiro: 'Quantidade de Passageiros',
  resultadoPlaca: 'Resultado da Placa',
  caminhao: 'Caminhão',
  implemento: 'Implemento',
  agregado: 'Agregado',
  somenteImplemento: 'Somente Implemento',
  valorTotalConjunto: 'Valor Total do Conjunto',
  valorCotaParticipacao: 'Valor da Cota de Participação',
  valorParticipacaoMinimo: 'Valor Mínimo de Participação',
  qtdRecusa: 'Quantidade de Recusas',
  numeroMotor: 'Número do Motor',
  tipoCambio: 'Tipo de Câmbio',
  somenteAgregado: 'Somente Agregado',
  descricaoAgregado: 'Descrição do Agregado',
  codTipoVeiculo: 'Código do Tipo de Veículo',
  codigoMarca: 'Código da Marca',
  codigoModelo: 'Código do Modelo',
  resultadoFipe: 'Resultado FIPE',
  valorFipe: 'Valor FIPE',
  cotaTabela: 'Cota da Tabela',
  cep_pernoite: 'CEP do Pernoite',
  rua_pernoite: 'Rua do Pernoite',
  numero_pernoite: 'Número do Pernoite',
  complemento_pernoite: 'Complemento do Pernoite',
  bairro_pernoite: 'Bairro do Pernoite',
  cidade_pernoite: 'Cidade do Pernoite',
  estado_pernoite: 'Estado do Pernoite',
  api_cep_resultado_pernoite: 'Resultado da API CEP Pernoite',
  veiculo_saiu_concessionaria: 'Veículo Saiu da Concessionária',
  data_veiculo_saiu_concessionaria: 'Data Que o Veículo Saiu da Concessionária',
  data_vencimento_cotacao: 'Data de Vencimento da Cotação',
  invoice_documento: 'Documento da Nota Fiscal',
  reason_refusal: 'Motivo da Recusa',
  informacao_adicional: 'Informação Adicional',
  vehicle_filled_manually: 'Veículo Preenchido Manualmente',
  short_inspection_link: 'Link Curto da Vistoria',
  shortInspectionLink: 'Link Curto da Vistoria',
  rules_engine_result: 'Resultado do Motor de Regras',
  rulesEngineResult: 'Resultado do Motor de Regras',
  needInspection: 'Necessita Vistoria',
  need_inspection: 'Necessita Vistoria',
};

export const TRANSLATED_INSURED_FIELDS = {
  name: 'Nome do segurado',
  civilName: 'Nome cívil do segurado',
  birthDate: 'Data de Nascimento do segurado',
  ppeDescription: 'Descrição PPE',
  companyId: 'ID da Empresa',
  brokerId: 'ID da Corretora',
  userId: 'ID do Usuário',
  type: 'Tipo do segurado',
  socialName: 'Nome Social do segurado',
  taxId: 'CPF/CNPJ do segurado',
  stateRegistrationNumber: 'Registro Estadual do segurado',
  driverLicenseNumber: 'Número da CNH  do segurado',
  driverLicenseCategory: 'Categoria da CNH do segurado',
  email: 'E-mail do segurado',
  phone: 'Telefone do segurado',
  cellphone: 'Celular do segurado',
  zipCode: 'CEP do segurado',
  address: 'Endereço do segurado',
  number: 'Número do segurado',
  neighborhood: 'Bairro do segurado',
  complement: 'Complemento do segurado',
  state: 'Estado do segurado',
  city: 'Cidade do segurado',
  country: 'País do segurado',
  isCepApiResult: 'Resultado API CEP',
  legalRepresentative: 'Representante Legal',
  representativeCpf: 'CPF do Representante',
  dueDay: 'Dia de Vencimento',
  activationDate: 'Data de Ativação',
  driverLicenseExpiryDate: 'Data de Vencimento da CNH',
  sgaAssociateCode: 'Código do Associado SGA',
  integrationId: 'ID de Integração',
  indicatorId: 'ID do Indicador',
  lgpdTermSigned: 'Termo LGPD Assinado',
  gender: 'Gênero',
  billingType: 'Tipo de Cobrança',
  situationCode: 'Código da Situação',
  situation: 'Situação',
  password: 'Senha',
  verified: 'Verificado',
  verificationCode: 'Código de Verificação',
  needPasswordChange: 'Necessita Trocar Senha',
  statusId: 'ID do Status',
  hasVehicle: 'Possui Veículo',
  individualInvoice: 'Boleto Individual',
  doesNotHaveDriverLicense: 'Não Possui CNH',
  maritalStatus: 'Estado Civil do segurado',
  marriageRegime: 'Regime de Casamento do segurado',
  height: 'Altura do segurado',
  weight: 'Peso do segurado',
  isPoliticallyExposed: 'Segurado Politicamente Exposto',
  nome: 'Nome do segurado',
  nome_civil: 'Nome cívil do segurado',
  dataNascimento: 'Data de Nascimento do segurado',
  ppe_description: 'Descrição PPE',
  id_empresa: 'ID da Empresa',
  id_regional: 'ID da Corretora',
  id_usuario: 'ID do Usuário',
  tipo: 'Tipo do segurado',
  nome_social: 'Nome Social do segurado',
  cpfcnpj: 'CPF/CNPJ do segurado',
  rg_ie: 'Registro Estadual do segurado',
  cnh: 'Número da CNH do segurado',
  catCnh: 'Categoria da CNH do segurado',
  telefone: 'Telefone do segurado',
  celular: 'Celular do segurado',
  cep: 'CEP do segurado',
  endereco: 'Endereço do segurado',
  numero: 'Número do segurado',
  bairro: 'Bairro do segurado',
  complemento: 'Complemento do segurado',
  estado: 'Estado do segurado',
  cidade: 'Cidade do segurado',
  pais: 'País do segurado',
  api_cep_resultado: 'Resultado API CEP',
  representanteLegal: 'Representante Legal',
  cpfRepresentante: 'CPF do Representante',
  diaVencimento: 'Dia de Vencimento',
  dataAtivacao: 'Data de Ativação',
  dataVencimentoCnh: 'Data de Vencimento da CNH',
  codigoAssociadoSGA: 'Código do Associado SGA',
  id_integracao: 'ID de Integração',
  id_indicador: 'ID do Indicador',
  termoLGPDAssinado: 'Termo LGPD Assinado',
  sexo: 'Gênero do segurado',
  tipo_Cobranca: 'Tipo de Cobrança',
  codigo_situacao: 'Código da Situação',
  situacao: 'Situação do segurado',
  senha: 'Senha do segurado',
  verificado: 'Segurado Verificado',
  codigoVerificacao: 'Código de Verificação',
  trocarSenha: 'Necessita Trocar Senha',
  id_status: 'ID do Status',
  possuiVeiculo: 'Possui Veículo',
  boletoIndividual: 'Boleto Individual',
  naoPossuiCnh: 'Segurado Não Possui CNH',
  estadoCivil: 'Estado Civil do segurado',
  regimeCasamento: 'Regime de Casamento do segurado',
  altura: 'Altura do segurado',
  peso: 'Peso do segurado',
  politicamente_exposto: 'Politicamente Exposto',
};

export const TRANSLATED_DRIVER_FIELDS = {
  id: 'Id do Condutor',
  apolice_id: 'Id da Apólice do Condutor',
  tax_id: 'CPF do Condutor',
  name: 'Nome do Condutor',
  social_name: 'Condutor usa Nome Social',
  civil_name: 'Nome Civil do Condutor',
  gender: 'Gênero do Condutor',
  birthdate: 'Data de Nascimento do Condutor',
  email: 'E-mail do Condutor',
  apoliceId: 'Id da Apólice do Condutor',
  taxId: 'CPF do Condutor',
  socialName: 'Condutor usa Nome Social',
  civilName: 'Nome Civil do Condutor',
};

export const TRANSLATED_POLICY_FIELDS = {
  apolice_id: 'Id da Apólice',
  tipo_apolice: 'Tipo de Apólice',
  associado_id: 'Id do Associado',
  idStatusApolice: 'Status da Apólice',
  premio: 'Prêmio',
  qtd_parcelas: 'Quantidade de Parcelas',
  dia_vencimento: 'Dia do Vencimento',
  id_tipo_pagamento: 'Tipo de Pagamento',
  data_ativacao: 'Data de Ativação',
  data_fim_vigencia_apolice: 'Data Fim da Vigência',
  meses_vigencia: 'Meses de Vigência',
  increase_questions: 'Perguntas Adicionais',
  increase_answers: 'Respostas Adicionais',
  charges: 'Carregamentos',
  insurance_policy: 'PDF da Apólice de Seguro',
  payment_link: 'Link de Pagamento',
  data_cancelamento: 'Data de Cancelamento',
  motivo_cancelamento: 'Motivo do Cancelamento',
  id_estipulante: 'Id do Estipulante',
  data_reembolso: 'Data de Reembolso',
  valor_reembolso: 'Valor do Reembolso',
  desconto: 'Desconto',
  bonus: 'Bônus',
  dados_pagamento: 'Dados de Pagamento',
  calculation_version: 'Versão de Cálculo',
  tariff_prize: 'Prêmio Tarifário',
  iof_value: 'Valor de IOF',
  interest: 'Juros',
  cnseg_ci: 'CI da CNSeg',
  short_payment_link: 'Link de Pagamento Curto',
  bonus_confirmed: 'Bônus Confirmado',
  creation_type: 'Tipo de Criação',
  activated_policy_number: 'Número da Apólice Ativada',
  id: 'Id da Apólice',
  policyType: 'Tipo de Apólice',
  insuredId: 'Id do Associado',
  statusId: 'Status da Apólice',
  prize: 'Prêmio',
  numberOfInstallments: 'Quantidade de Parcelas',
  dueDay: 'Dia do Vencimento',
  paymentTypeId: 'Tipo de Pagamento',
  activationDate: 'Data de Ativação',
  policyEndDate: 'Data Fim da Vigência',
  validityMonths: 'Meses de Vigência',
  increaseQuestions: 'Perguntas Agravos',
  increaseAnswers: 'Respostas Agravos',
  insurancePolicy: 'PDF da Apólice de Seguro',
  paymentLink: 'Link de Pagamento',
  cancellationDate: 'Data de Cancelamento',
  cancellationReason: 'Motivo do Cancelamento',
  stipulatorId: 'Id do Estipulante',
  refundDate: 'Data de Reembolso',
  refundValue: 'Valor do Reembolso',
  discount: 'Desconto',
  paymentData: 'Dados de Pagamento',
  calculationVersion: 'Versão de Cálculo',
  tariffPrize: 'Prêmio Tarifário',
  iofValue: 'Valor de IOF',
  cnsegCi: 'CI da CNSeg',
  shortPaymentLink: 'Link de Pagamento Curto',
  bonusConfirmed: 'Bônus Confirmado',
  creationType: 'Tipo de Criação',
  activatedPolicyNumber: 'Número da Apólice Ativada',
};

export const TRANSLATED_POLICY_REFUND_FIELDS = {
  status: 'Status da Restituição',
  refund_value: 'Valor da Restituição',
  effective_date: 'Data de Efetivação da Restituição',
  payment_method: 'Método de Restituição',
};

export const EXCLUDED_FIELDS = [
  'createdAt',
  'created_at',
  'updatedAt',
  'updated_at',
  'deletedAt',
  'deleted_at',
  'legacy_coverage_offered',
  'legacyCoverageOffered',
  'legacy_coverage_contracted',
  'legacyCoverageContracted',
  'coverage_offered',
  'coverageOffered',
  'coverage_contracted',
  'coverageContracted',
  'user',
  'company',
  'lastUpdateUserId',
];

export const DATE_FIELDS = [
  'dataNascimento',
  'dataVencimentoCnh',
  'data_ativacao',
  'data_fim_vigencia_apolice',
  'data_cancelamento',
  'data_reembolso',
  'dataAtivacao',
  'data_veiculo_saiu_concessionaria',
  'data_vencimento_cotacao',
  'proposal_date',
  'dataAdesaoReal',
  'dataSincronizacaoSTAR',
  'dataVencimentoAvista',
  'dataAceite',
  'dataVistoria',
  'dataAdesao',
  'dataFinalizacao',
  'birthdate',
  'inicioVigencia',
  'fimVigencia',
  'birthDate',
  'effective_date',
];
